import { Body, Caption, Flex, LazyImage, Shape } from '@teko/ds-desktop';
import { DiscountColored, VoucherTagColored } from '@teko/ds-icon';
import { formatCurrency } from '@teko/teko-ecommerce';
import { useTenantConfig } from 'contexts';
import { t } from 'i18n';
import { useState } from 'react';
import { IPromotionBenefit } from 'types';

interface IBenefit {
  name?: string;
  image?: string;
  quantity?: number;
  icon?: React.ReactNode;
}

interface PromotionBenefitInfoProps {
  promotionBenefit: IPromotionBenefit;
  showFullBenefits?: boolean;
}
export const PromotionBenefitInfo: React.FC<PromotionBenefitInfoProps> = (
  props,
) => {
  const { numberDisplayFormat } = useTenantConfig();
  const { promotionBenefit, showFullBenefits: initialShowFullBenefits } = props;
  const [showFullBenefits, setShowFullBenefits] = useState(
    initialShowFullBenefits,
  );

  const getBenefits = (benefit: IPromotionBenefit) => {
    let count = 0;
    const benefits = [];

    const { discount, voucher, gifts } = benefit;
    const discountValue = discount?.flat || discount?.percent || 0;
    if (discount && discountValue > 0) {
      count++;
      benefits.push({
        icon: (
          <Shape>
            <DiscountColored size={24} />
          </Shape>
        ),
        name: `${t('Giảm ngay')} ${
          discount?.flat
            ? formatCurrency(discountValue, numberDisplayFormat)
            : `${discountValue}%` +
              (discount.maxAmount
                ? ` ${t('Giảm tối đa')} ${formatCurrency(
                    discount.maxAmount,
                    numberDisplayFormat,
                  )}`
                : '')
        }`,
      });
    }
    if (voucher) {
      count++;
      benefits.push({
        icon: (
          <Shape>
            <VoucherTagColored size={24} />
          </Shape>
        ),
        name: voucher.name,
        quantity: voucher.quantity,
      });
    }
    if (gifts && !!gifts.length) {
      count++;
      gifts.forEach((gift) => {
        benefits.push({
          image: gift.imageUrl,
          name: gift.name,
          quantity: gift.quantity,
        });
      });
    }
    return { numberOfBenefit: count, benefits };
  };

  const benefits: IBenefit[] = getBenefits(promotionBenefit).benefits;

  return benefits.length ? (
    <Flex direction="column" gap="s4">
      <Shape
        border="1px solid #ffa39e"
        borderRadius="m"
        style={{ padding: '2px 8px', background: '#FFF1F0' }}
      >
        <Caption level={1} color="#f5222d">
          {t('NHẬN NGAY ƯU ĐÃI')}
        </Caption>
      </Shape>
      <Flex direction="column" gap="s4">
        {benefits
          .slice(0, showFullBenefits ? benefits.length : 3)
          .map(({ name, image, quantity, icon }, index) => (
            <Flex key={`${index}${name}`} height="24px" align="center">
              {icon ? (
                <>{icon}</>
              ) : (
                <LazyImage
                  borderRadius="8px"
                  src={image || ''}
                  width={22}
                  height={22}
                />
              )}
              <Body level={1} line={2} marginLeft="s8">
                {quantity && quantity > 1 && (
                  <span
                    style={{ color: '#2b2b2b' }}
                  >{`Tặng ${quantity} x `}</span>
                )}
                {name}
              </Body>
            </Flex>
          ))}
      </Flex>
      {benefits.length > 3 && !initialShowFullBenefits && (
        <Shape>
          {!showFullBenefits ? (
            <Body
              color="textSecondary"
              level={1}
              onClick={() => setShowFullBenefits(true)}
            >
              {t('Xem thêm')}
            </Body>
          ) : (
            <Body
              color="textSecondary"
              level={1}
              onClick={() => setShowFullBenefits(false)}
            >
              {t('Rút gọn')}
            </Body>
          )}
        </Shape>
      )}
    </Flex>
  ) : null;
};
